
class StudentListCacheService

    ### @ngInject ###
    constructor: ($state, localStorageService) ->
        @state = $state
        @localStorage = localStorageService
        @statesToMonitor = {}
        @cachedParams = {}

    monitorState: (stateName, uniqueId) ->
        @statesToMonitor[stateName] = uniqueId
        return

    localStorageKey: (stateName) ->
        "param_cache.#{stateName}"

    storeParams: (stateName, params) ->
        @cachedParams[stateName] = params;
        @localStorage.set(@localStorageKey(stateName), params)
        return

    getParams: (stateName) ->

        if not @cachedParams[stateName]
            key = @localStorageKey(stateName)
            stored = @localStorage.get(key)
            @cachedParams[stateName] = stored

        return angular.copy(@cachedParams[stateName])

    restoreParams: (stateName, params) ->

        newParams = @getParams(stateName)
        idName = @statesToMonitor[stateName]

        if not newParams
            @storeParams(stateName, params)
            params.noRestore = true
            return params

        else if newParams[idName] != params[idName]
            newParams[idName] = params[idName]
            newParams.noRestore = true
            newParams.page = 1
            newParams.search = ""
            return newParams

        else
            newParams.noRestore = true
            return newParams

    isMonitored: (state) ->
        return !!@statesToMonitor[state.name]

    stateChangeStart: (event, toState, toParams, fromState, fromParams) =>
        if toState.name == fromState.name then return
        @leaveState(event, fromState, fromParams)
        @enterState(event, toState, toParams, fromState)
        return

    leaveState: (event, state, params) ->
        if not @isMonitored(state) then return
        @storeParams state.name, params
        return

    enterState: (event, state, params, fromState) ->
        if not @isMonitored(state) then return
        if params.noRestore then return
        newParams = @restoreParams(state.name, params)
        event.preventDefault()
        @state.go(state.name, newParams);

    ### @ngInject ###
    @config: ($rootScope, StudentListCache) ->
        $rootScope.$on '$stateChangeStart', StudentListCache.stateChangeStart
        StudentListCache.monitorState 'students', 'slug'
        StudentListCache.monitorState 'participants', 'slug'
        return


module
    .service('StudentListCache', StudentListCacheService)
    .run(StudentListCacheService.config)
